import { Spinner } from "../../../components/Spinner";
import { useAdminProducts } from "../../../lib/queries";
import { DEFAULT_TNPL, TnplSettingsForm } from "../AdminSettingsPage";
import { LendingFrame } from "./LendingShared";

/** Everything the customer reads about Travel Now · Pay Later: rollout, limits, rate and legal texts. */
export function AdminLendingSettingsPage() {
  const products = useAdminProducts();
  return (
    <LendingFrame title="Configuración de «Viaja ahora, paga después»" subtitle="Audiencia, límites, tasa de referencia y textos legales que aprueba Peso a Peso.">
      {products.isLoading && <div className="page-state"><Spinner label="Cargando ajustes" /></div>}
      {products.data && <TnplSettingsForm initial={{ ...DEFAULT_TNPL, ...(products.data.settings.tnpl ?? {}) }} />}
    </LendingFrame>
  );
}
